import React from 'react';
import AlarmModal from 'src/components/Template/AlarmModal';
import AutoModalSlide from 'src/components/Template/AutoModalSlide';
import BasicFullImage from 'src/components/Template/BasicFullImage';
import BottomSheetImage from 'src/components/Template/BottomSheetImage';
import BottomSheetSlide from 'src/components/Template/BottomSheetSlide';
import CouponBottomSheet from 'src/components/Template/CouponBottomSheet';
import BasicFullCountdown from 'src/components/Template/BasicFullCountdown';
import FullDualImage from 'src/components/Template/FullDualImage';
import ImageBottomSheet from 'src/components/Template/ImageBottomSheet';
import ListModal from 'src/components/Template/ListModal';
import ModalSlide from 'src/components/Template/ModalSlide';
import RadiusFullCountdown from 'src/components/Template/RadiusFullCountdown';
import RadiusModalSlide from 'src/components/Template/RadiusModalSlide';
import SimpleModalSlide from 'src/components/Template/SimpleModalSlide';
import SlideFullImage from 'src/components/Template/SlideFullImage';
import SlideModalImage from 'src/components/Template/SlideModalImage';
import SlideModalRound from 'src/components/Template/SlideModalRound';

import BasicFullCountdownHTML from 'src/components/TemplateHTML/BasicFullCountdownHTML';
import BottomSheetImageHTML from 'src/components/TemplateHTML/BottomSheetImageHTML';
import RadiusModalSlideHTML from 'src/components/TemplateHTML/RadiusModalSlideHTML';
import FullDualImageHTML from 'src/components/TemplateHTML/FullDualImageHTML';
import SimpleSurveyHTML from 'src/components/TemplateHTML/SimpleSurveyHTML';
import SimpleModalSlideHTML from 'src/components/TemplateHTML/SimpleModalSlideHTML';
import BottomSheetSlideHTML from 'src/components/TemplateHTML/BottomSheetSlideHTML';
import NPSModalDialHTML from 'src/components/TemplateHTML/NPSModalDialHTML';
import BasicFullImageHTML from 'src/components/TemplateHTML/BasicFullImageHTML';
import RadiusFullCountdownHTML from 'src/components/TemplateHTML/RadiusFullCountdownHTML';
import ModalSlideHTML from 'src/components/TemplateHTML/ModalSlideHTML';
import SlideModalRoundHTML from 'src/components/TemplateHTML/SlideModalRoundHTML';
import ModalSliderSurveyHTML from 'src/components/TemplateHTML/ModalSliderSurveyHTML';
import SlideFullImageHTML from 'src/components/TemplateHTML/SlideFullImageHTML';
import SlideModalImageHTML from 'src/components/TemplateHTML/SlideModalImageHTML';
import AutoModalSlideHTML from 'src/components/TemplateHTML/AutoModalSlideHTML';
import CouponBottomSheetHTML from 'src/components/TemplateHTML/CouponBottomSheetHTML';
import ImageBottomSheetHTML from 'src/components/TemplateHTML/ImageBottomSheetHTML';
import ListModalHTML from 'src/components/TemplateHTML/ListModalHTML';
import AlarmModalHTML from 'src/components/TemplateHTML/AlarmModalHTML';

import BottomSheetImageTracking from 'src/components/TemplateTracking/BottomSheetImageTracking';
import BasicFullCountdownTracking from 'src/components/TemplateTracking/BasicFullCountdownTracking';
import RadiusModalSlideTracking from 'src/components/TemplateTracking/RadiusModalSlideTracking';
import FullDualImageTracking from 'src/components/TemplateTracking/FullDualImageTracking';
import ModalSlideTracking from 'src/components/TemplateTracking/ModalSlideTracking';
import SlideModalRoundTracking from 'src/components/TemplateTracking/SlideModalRoundTracking';
import SimpleModalSlideTracking from 'src/components/TemplateTracking/SimpleModalSlideTracking';
import BottomSheetSlideTracking from 'src/components/TemplateTracking/BottomSheetSlideTracking';
import BasicFullImageTracking from 'src/components/TemplateTracking/BasicFullImageTracking';
import RadiusFullCountdownTracking from 'src/components/TemplateTracking/RadiusFullCountdownTracking';
import SlideFullImageTracking from 'src/components/TemplateTracking/SlideFullImageTracking';
import SlideModalImageTracking from 'src/components/TemplateTracking/SlideModalImageTracking';
import AutoModalSlideTracking from 'src/components/TemplateTracking/AutoModalSlideTracking';
import CouponBottomSheetTracking from 'src/components/TemplateTracking/CouponBottomSheetTracking';
import ImageBottomSheetTracking from 'src/components/TemplateTracking/ImageBottomSheetTracking';
import ListModalTracking from 'src/components/TemplateTracking/ListModalTracking';
import AlarmModalTracking from 'src/components/TemplateTracking/AlarmModalTracking';
import SimpleModalHTML from 'src/components/TemplateHTML/SimpleModalHTML';
import SimpleModal from 'src/components/Template/SimpleModal';
import SimpleModalTracking from 'src/components/TemplateTracking/SimpleModalTracking';
import MultipleChoiceSurveyTracking from 'src/components/templates/MultipleChoiceSurvey/MultipleChoiceSurveyTracking';
import MultipleChoiceSurvey from 'src/components/templates/MultipleChoiceSurvey/MultipleChoiceSurveyView';
import MultipleChoiceSurveyHTML from 'src/components/templates/MultipleChoiceSurvey/MultipleChoiceSurveyHTML';
import ShortAnswerSurveyHTML from 'src/components/templates/ShortAnswerSurvey/ShortAnswerSurveyHTML';
import ShortAnswerSurveyTracking from 'src/components/templates/ShortAnswerSurvey/ShortAnswerSurveyTracking';
import RatingAnswerSurvey from 'src/components/templates/RatingAnswerSurvey/RatingAnswerSurveyView';
import RatingAnswerSurveyHTML from 'src/components/templates/RatingAnswerSurvey/RatingAnswerSurveyHTML';
import RatingAnswerSurveyTracking from 'src/components/templates/RatingAnswerSurvey/RatingAnswerSurveyTracking';
import { ShortAnswerSurveyStyles } from 'src/components/templates/ShortAnswerSurvey/initStyles';
import { MultipleChoiceSurveyStyles } from 'src/components/templates/MultipleChoiceSurvey/initStyles';
import { RatingAnswerSurveyStyles } from 'src/components/templates/RatingAnswerSurvey/initStyles';
import ShortAnswerSurveyView from 'src/components/templates/ShortAnswerSurvey/ShortAnswerSurveyView';

import AutoSquareSlide from 'src/components/Template/AutoSquareSlide';
import AutoSquareSlideHTML from 'src/components/TemplateHTML/AutoSquareSlideHTML';
import AutoSquareSlideTracking from 'src/components/TemplateTracking/AutoSquareSlideTracking';
import CarouselSlideModalTracking from 'src/components/TemplateTracking/CarouselSlideModalTracking';
import CarouselSlideModalHTML from 'src/components/TemplateHTML/CarouselSlideModalHTML';
import CarouselSlideModal from 'src/components/Template/CarouselSlideModal';
import SimpleIconModal from 'src/components/Template/SimpleIconModal';
import SimpleIconModalHTML from 'src/components/TemplateHTML/SimpleIconModalHTML';
import SimpleIconModalTracking from 'src/components/TemplateTracking/SimpleIconModalTracking';

export const TEMPLATES_VIEW: any = {
  'BASIC FULL COUNTDOWN': <BasicFullCountdown />,
  'BOTTOM SHEET IMAGE': <BottomSheetImage />,
  'RADIUS MODAL SLIDE': <RadiusModalSlide />,
  'FULL DUAL IMAGE': <FullDualImage />,

  'MODAL SLIDE': <ModalSlide />,
  'SLIDE MODAL ROUND': <SlideModalRound />,
  'SIMPLE MODAL SLIDE': <SimpleModalSlide />,
  'BOTTOM SHEET SLIDE': <BottomSheetSlide />,

  'BASIC FULL IMAGE': <BasicFullImage />,
  'RADIUS FULL COUNTDOWN': <RadiusFullCountdown />,
  'SIMPLE MODAL': <SimpleModal />,
  'MULTIPLE CHOICE SURVEY': <MultipleChoiceSurvey />,

  'SLIDE FULL IMAGE': <SlideFullImage />,
  'SLIDE MODAL IMAGE': <SlideModalImage />,
  'AUTO MODAL SLIDE': <AutoModalSlide />,
  'COUPON BOTTOM SHEET': <CouponBottomSheet />,

  'SHORT ANSWER SURVEY': <ShortAnswerSurveyView />,
  'RATING ANSWER SURVEY': <RatingAnswerSurvey />,
  'IMAGE BOTTOM SHEET': <ImageBottomSheet />,
  'LIST MODAL': <ListModal />,
  'ALARM MODAL': <AlarmModal />,

  'AUTO SQUARE SLIDE': <AutoSquareSlide />,
  'CAROUSEL SLIDE MODAL': <CarouselSlideModal />,
  'SIMPLE ICON MODAL': <SimpleIconModal />
};

export const TEMPLATES_HTML = {
  'BASIC FULL COUNTDOWN': <BasicFullCountdownHTML />,
  'BOTTOM SHEET IMAGE': <BottomSheetImageHTML />,
  'RADIUS MODAL SLIDE': <RadiusModalSlideHTML />,
  'FULL DUAL IMAGE': <FullDualImageHTML />,

  'MODAL SLIDE': <ModalSlideHTML />,
  'SLIDE MODAL ROUND': <SlideModalRoundHTML />,
  'SIMPLE MODAL SLIDE': <SimpleModalSlideHTML />,
  'BOTTOM SHEET SLIDE': <BottomSheetSlideHTML />,

  'BASIC FULL IMAGE': <BasicFullImageHTML />,
  'RADIUS FULL COUNTDOWN': <RadiusFullCountdownHTML />,
  'SIMPLE MODAL': <SimpleModalHTML />,
  'MULTIPLE CHOICE SURVEY': <MultipleChoiceSurveyHTML />,

  'SLIDE FULL IMAGE': <SlideFullImageHTML />,
  'SLIDE MODAL IMAGE': <SlideModalImageHTML />,
  'AUTO MODAL SLIDE': <AutoModalSlideHTML />,
  'COUPON BOTTOM SHEET': <CouponBottomSheetHTML />,

  'SHORT ANSWER SURVEY': <ShortAnswerSurveyHTML />,
  'RATING ANSWER SURVEY': <RatingAnswerSurveyHTML />,
  'IMAGE BOTTOM SHEET': <ImageBottomSheetHTML />,
  'LIST MODAL': <ListModalHTML />,
  'ALARM MODAL': <AlarmModalHTML />,

  'AUTO SQUARE SLIDE': <AutoSquareSlideHTML />,
  'CAROUSEL SLIDE MODAL': <CarouselSlideModalHTML />,
  'SIMPLE ICON MODAL': <SimpleIconModalHTML />
};

export const TEMPLATES_TRACKING: any = {
  'BASIC FULL COUNTDOWN': <BasicFullCountdownTracking />,
  'BOTTOM SHEET IMAGE': <BottomSheetImageTracking />,
  'RADIUS MODAL SLIDE': <RadiusModalSlideTracking />,
  'FULL DUAL IMAGE': <FullDualImageTracking />,

  'MODAL SLIDE': <ModalSlideTracking />,
  'SLIDE MODAL ROUND': <SlideModalRoundTracking />,
  'SIMPLE MODAL SLIDE': <SimpleModalSlideTracking />,
  'BOTTOM SHEET SLIDE': <BottomSheetSlideTracking />,

  'BASIC FULL IMAGE': <BasicFullImageTracking />,
  'RADIUS FULL COUNTDOWN': <RadiusFullCountdownTracking />,
  'SIMPLE MODAL': <SimpleModalTracking />,
  'MULTIPLE CHOICE SURVEY': <MultipleChoiceSurveyTracking />,

  'SLIDE FULL IMAGE': <SlideFullImageTracking />,
  'SLIDE MODAL IMAGE': <SlideModalImageTracking />,
  'AUTO MODAL SLIDE': <AutoModalSlideTracking />,
  'COUPON BOTTOM SHEET': <CouponBottomSheetTracking />,

  'SHORT ANSWER SURVEY': <ShortAnswerSurveyTracking />,
  'RATING ANSWER SURVEY': <RatingAnswerSurveyTracking />,
  'IMAGE BOTTOM SHEET': <ImageBottomSheetTracking />,
  'LIST MODAL': <ListModalTracking />,
  'ALARM MODAL': <AlarmModalTracking />,

  'AUTO SQUARE SLIDE': <AutoSquareSlideTracking />,
  'CAROUSEL SLIDE MODAL': <CarouselSlideModalTracking />,
  'SIMPLE ICON MODAL': <SimpleIconModalTracking />
};

export const TEMPLATES_STYLE = template => {
  const STYLE = {
    'MULTIPLE CHOICE SURVEY': MultipleChoiceSurveyStyles(),
    'SHORT ANSWER SURVEY': ShortAnswerSurveyStyles(),
    'RATING ANSWER SURVEY': RatingAnswerSurveyStyles()
  };

  return STYLE[template];
};
